export default "__VITE_ASSET__Cb9IHuTD__"